"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var R = _interopRequireWildcard(require("ramda"));
var _utils = require("@trs/utils");
var _FormulaMember = _interopRequireDefault(require("../FormulaMember"));
var _errors = _interopRequireDefault(require("../../errors"));
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _objectDestructuringEmpty(obj) { if (obj == null) throw new TypeError("Cannot destructure " + obj); }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
var ContributionBlock = function ContributionBlock(_ref) {
  var props = _extends({}, (_objectDestructuringEmpty(_ref), _ref));
  var labels = props.labels,
    data = props.data,
    thresholdIndex = props.thresholdIndex,
    errors = props.errors,
    ruleIndex = props.ruleIndex;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "".concat(R.path([thresholdIndex, 'contribution', 'formulaItems', 'generic'], errors) ? 'formula-empty-error-container' : '', " threshold-contribution threshold-block")
  }, /*#__PURE__*/_react["default"].createElement("strong", {
    className: "threshold-element threshold-header"
  }, (0, _utils.toUpper)(labels.PENSION_PENSIONABLE_SALARY_THEN_LABEL)), /*#__PURE__*/_react["default"].createElement("span", {
    className: "threshold-element"
  }, labels.PENSION_PENSIONABLE_SALARY_CONTRIBUTION_LABEL), !(0, _utils.isBlank)(R.path(['contribution', 'formulaItems'], data)) && data.contribution.formulaItems.map(function (item, index) {
    return /*#__PURE__*/_react["default"].createElement(_FormulaMember["default"], _extends({}, props, {
      member: item,
      noDelete: index === 0 && item.type !== 'function',
      ruleIndex: ruleIndex,
      key: item.key,
      keysPath: [thresholdIndex, 'contribution', 'formulaItems', index]
    }));
  }), /*#__PURE__*/_react["default"].createElement("span", {
    className: "threshold-element contribution-element"
  }, labels.PENSION_CONTRIBUTION_OF_PENSIONABLE), R.path([thresholdIndex, 'contribution', 'formulaItems', 'generic'], errors) && /*#__PURE__*/_react["default"].createElement(_errors["default"], {
    className: "formula-empty-error-label",
    message: R.path([thresholdIndex, 'contribution', 'formulaItems', 'generic'], errors)
  }));
};
ContributionBlock.defaultProps = {
  errors: {},
  disabled: false
};
ContributionBlock.propTypes = {
  disabled: _propTypes["default"].bool,
  /* The threshold index */
  thresholdIndex: _propTypes["default"].number.isRequired,
  /* The rule index */
  ruleIndex: _propTypes["default"].number.isRequired,
  /* The rewards labels */
  labels: _propTypes["default"].objectOf(_propTypes["default"].string).isRequired,
  /* The root data for each threshold */
  data: _propTypes["default"].shape({}).isRequired,
  /* The errros object */
  errors: _propTypes["default"].shape({})
};
ContributionBlock.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "ContributionBlock",
  "props": {
    "errors": {
      "defaultValue": {
        "value": "{}",
        "computed": false
      },
      "description": "",
      "type": {
        "name": "shape",
        "value": {}
      },
      "required": false
    },
    "disabled": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "description": "",
      "type": {
        "name": "bool"
      },
      "required": false
    },
    "thresholdIndex": {
      "description": "",
      "type": {
        "name": "number"
      },
      "required": true
    },
    "ruleIndex": {
      "description": "",
      "type": {
        "name": "number"
      },
      "required": true
    },
    "labels": {
      "description": "",
      "type": {
        "name": "objectOf",
        "value": {
          "name": "string"
        }
      },
      "required": true
    },
    "data": {
      "description": "",
      "type": {
        "name": "shape",
        "value": {}
      },
      "required": true
    }
  }
};
var _default = ContributionBlock;
exports["default"] = _default;